var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusStampSpecialGreen = function SvgStatusStampSpecialGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5739 6.83369C35.2539 2.79896 30.3427 0.572098 24.7583 0.572098H24.7506C13.6201 0.572098 2.92555 9.73559 0.913634 21.0018C-0.111447 26.7591 1.18903 32.1982 4.57027 36.3105C7.8903 40.3452 12.8015 42.5721 18.3859 42.5721H18.3936C29.5241 42.5721 40.2186 33.4086 42.2305 22.1424C43.2556 16.3851 41.9551 10.9538 38.5739 6.83369V6.83369ZM32.301 21.1647C31.1918 27.3643 25.332 32.4154 19.2351 32.4154C16.4964 32.4154 14.1249 31.368 12.5644 29.467C10.9503 27.5117 10.3459 24.8503 10.8585 21.9872C11.9677 15.7877 17.8275 10.7365 23.9244 10.7365C26.663 10.7365 29.0345 11.784 30.5951 13.685C32.2092 15.6403 32.8135 18.3016 32.301 21.1647Z",
    fill: "url(#paint0_linear_604_3621)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4845 12.3814L26.2346 15.1126L25.4313 4.52922C25.3702 3.73779 24.2686 3.74555 23.9243 4.52922L19.3344 15.198L13.8571 12.3659C13.3522 12.1021 12.7096 12.7616 12.985 13.2582L17.0165 20.5906L16.8482 20.9863C16.7947 21.1182 16.7564 21.2501 16.7335 21.382L10.3382 28.5048C9.8945 29.0014 10.3076 29.6532 10.9043 29.3971L17.093 26.6892L17.9574 38.0873C18.0186 38.8787 19.1202 38.871 19.4645 38.0873L24.3527 26.7202L29.5317 29.3971C30.0366 29.6609 30.6792 29.0014 30.4038 28.5048L26.5712 21.5294C26.6553 21.3044 26.7012 21.0639 26.6783 20.8388L26.6477 20.3966L33.0583 13.2582C33.502 12.7616 33.0889 12.1099 32.4922 12.3659L32.4845 12.3814ZM24.7276 20.8932C24.4216 22.5924 22.8151 23.9735 21.1398 23.9735C19.4645 23.9735 18.3476 22.5924 18.6459 20.8932C18.9519 19.1939 20.5584 17.8128 22.2337 17.8128C23.909 17.8128 25.0259 19.1939 24.7276 20.8932Z",
    fill: "#55AC68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_3621",
    x1: 7.11997,
    y1: 8.88296,
    x2: 39.0501,
    y2: 30.7092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FC5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52C5FF"
  })))));
};
export default SvgStatusStampSpecialGreen;